angular.module('unica_event_tag.event_tag_controllers')

.controller('EventTagCreateController', function(
	$rootScope, $scope, $state, $stateParams,
	EventTagCreateService
) {

	$rootScope.getEvent( $stateParams.event_id );

	$rootScope.eventTagData = {
		event_id: $stateParams.event_id,
	};

	$scope.saveEventTag = function()
	{
		$scope.showLoader();

		var eventTagData = angular.copy($rootScope.eventTagData);

		EventTagCreateService
			.create( eventTagData )
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {
					$scope.showSuccessMsg('Tag aggiunto con successo!', '');

					$state.go('app.event_tag.list', { event_id: $stateParams.event_id });
				}
			});
	};

});

